import React, { useState } from "react";

import Popover from "@mui/material/Popover";
import zIndex from "@mui/material/styles/zIndex";

export default function MuiPopover(props) {
  const popoverStyle = {
    "& .MuiPaper-root.MuiPopover-paper": {
      borderRadius: "24px",
      backgroundColor: "var(--color-primary-grey-20)",
      boxShadow: "var(--box-shadow-card)",
      padding: "8px",
      ...props.sx,
    },
    "&": {
      // zIndex: "50",
    },
  };
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
    props.trigger.props?.onClick && props.trigger.props?.onClick();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const TriggerComponent = props?.trigger?.component;
  const NewChild = React.cloneElement(props.children ? props.children : <></>, {
    close: handleClose,
  });
  return (
    <>
      {props.trigger && (
        <TriggerComponent
          aria-describedby={id}
          onClick={handleClick}
          {...props.trigger.props}
        />
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          "--color-primary-20": "#e5f1f7ff",
          "--color-primary-30": "#89dcffff",
          "--color-primary-40": "#67c3efff",
          "--color-primary-50": "#0078adff",
          "--color-primary-60": "#0c5273ff",
          "--color-primary-70": "#00364eff",
          "--color-primary-80": "#001e2bff",
          ...popoverStyle,
        }}
      >
        {/* {props.children} */}
        {NewChild}
      </Popover>
    </>
  );
}
